
import * as actions from './actionTypes'

export function language(lang) {
  return {
    type: actions.LANG,
    payload: lang
  }
}

export function result(res) {
  return {
    type: actions.RESULT,
    payload: res
  }
}

export function submit() {
  return {
    type: actions.SUBMIT
  }
}

export function reset() {
  return {
    type: actions.RESET,
  }
}

export function prev() {
  return {
    type: actions.PREV
  }
}

export function next() {
  return {
    type: actions.NEXT
  }
}



// WEBPACK FOOTER //
// ./src/questions/actions.js